import { ExceptionStatus, ExceptionType } from "../model/AttendanceException";

export const RESOLUTION_ACTIONS = [
  "sick",
  "family",
  "replacement",
  "approve",
  "reject",
  "replaced",
  "no_show",
  "clock_override",
  "clock_in",
  "mark_as_other",
] as const;

export type ResolutionAction = (typeof RESOLUTION_ACTIONS)[number];

export const isResolutionAction = (value: unknown): value is ResolutionAction =>
  typeof value === "string" &&
  (RESOLUTION_ACTIONS as readonly string[]).includes(value);

export interface AttendanceExceptionsRequest {
  page?: number;
  page_size?: number;
  shift_location?: string;
  shift_site?: string;
  exception_type?: ExceptionType;
  date_from?: string;
  date_to?: string;
  date?: string;
  status?: ExceptionStatus;
  search?: string;
  include_supervisor_clock?: boolean;
  enabled?: boolean;
}

export interface ResolveExceptionRequest {
  action?: ResolutionAction;
  reason?: string;
  resolution_notes?: string;
  confirmed_clock_time?: string;
  decisions?: Record<string, "approved" | "declined">;
}

export interface ExceptionCountRequest {
  shift_location?: string;
  shift_site?: string;
  status?: ExceptionStatus;
  include_supervisor_clock?: boolean;
  date?: string;
  date_from?: string;
  date_to?: string;
}
